import { makeStyles } from '@material-ui/core/styles';
import { standardSizes } from "../Select.styles";

var _getInputStyles = function _getInputStyles(_ref) {
  var isFocused = _ref.isFocused;
  var paddingTop = isFocused ? '12px' : '0px';
  return {
    height: '100%',
    display: 'flex',
    padding: '0px 4px',
    '& .MuiInput-root': {
      paddingTop: paddingTop
    }
  };
};

export var useStyles = makeStyles(function (theme) {
  var _theme$palette = theme.palette,
      grey = _theme$palette.grey,
      blue = _theme$palette.blue,
      red = _theme$palette.red,
      white = _theme$palette.white;
  return {
    textFieldRoot: {
      backgroundColor: function backgroundColor(_ref2) {
        var disabled = _ref2.disabled;
        return disabled ? grey[100] : white;
      },
      color: function color(_ref3) {
        var disabled = _ref3.disabled;
        return disabled ? grey[400] : 'inherit';
      },
      borderRadius: '2px',
      borderWidth: '1px',
      height: function height(_ref4) {
        var size = _ref4.size;
        return standardSizes[size].height;
      },
      width: function width(_ref5) {
        var fullWidth = _ref5.fullWidth,
            size = _ref5.size;
        return fullWidth ? '100%' : standardSizes[size].width;
      },
      // this will be applied when hovered (input text color change)
      '&:hover': {
        borderWidth: '1px'
      },
      // this will applied when hovered (input border color change)
      '&:hover $textFieldNotchedOutline': {
        borderColor: blue[100],
        borderWidth: '1px'
      },
      // this will be applied when focused (input border color change)
      '&$textFieldFocused $textFieldNotchedOutline': {
        borderColor: blue[300],
        borderWidth: '1px'
      }
    },
    textFieldFocused: {},
    textFieldNotchedOutline: {
      borderColor: function borderColor(_ref6) {
        var error = _ref6.error;
        return error ? red[200] : grey[200];
      }
    },
    input: _getInputStyles,
    inputLabel: function inputLabel(_ref7) {
      var menuIsOpen = _ref7.menuIsOpen;
      return {
        display: menuIsOpen ? 'none' : 'auto'
      };
    },
    root: function root(_ref8) {
      var fullWidth = _ref8.fullWidth,
          error = _ref8.error,
          disabled = _ref8.disabled;
      return {
        width: fullWidth ? '100%' : 'auto',
        '& .MuiFormLabel-root': {
          zIndex: 1,
          margin: '12px',
          top: '-2px',
          color: disabled ? grey[400] : 'default'
        },
        '& .MuiInputLabel-asterisk': {
          paddingLeft: '4px'
        },
        '& .MuiFormHelperText-root': {
          color: error ? red[500] : grey[600],
          fontSize: '12px',
          lineHeight: '16px',
          margin: 0
        },
        '& .MuiInput-underline': {
          '&:before': {
            content: '""',
            borderBottomWidth: '2px',
            borderBottomColor: error ? red[500] : grey[200]
          },
          '&:hover:not($disabled):before': {
            borderBottomColor: blue[100]
          },
          '&:after': {
            content: '""',
            borderBottomColor: blue[300],
            transition: "all 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
          }
        }
      };
    },
    inlineFieldRoot: {
      backgroundColor: function backgroundColor(_ref9) {
        var disabled = _ref9.disabled;
        return disabled ? grey[100] : white;
      },
      color: function color(_ref10) {
        var disabled = _ref10.disabled;
        return disabled ? grey[400] : 'inherit';
      },
      borderRadius: '2px',
      width: function width(_ref11) {
        var fullWidth = _ref11.fullWidth;
        return fullWidth ? '100%' : '320px';
      },
      minHeight: '48px',
      height: function height(_ref12) {
        var isMulti = _ref12.isMulti;
        return isMulti ? '100%' : '48px';
      }
    }
  };
});